<div class="modal__controls">
  <button class="btn-white modal__secondary" (click)="secondaryAction()">
    {{ secondaryActionTextKey() | translate }}
  </button>
  <button
    class="btn-primary modal__primary"
    [class.modal__primary--disabled]="terminateDisabledCondition()"
    [disabled]="terminateDisabledCondition()"
    (click)="primaryAction()"
  >
    {{ primaryActionTextKey() | translate }}
  </button>
</div>
